import { Table } from '@material-ui/core'
import { DadosUrbanizacao, Custo } from 'models/Viabilidade/Urbanizacao'
import NumberFormat from 'react-number-format'
import { TableContainerCustomizado, TableCellLabel, TableRowCinza, TableCellValor, TableRowVerde, TableCellBold, TableCellBoldAlignRight } from '../index.style'

const CartaoUrbanizacao: React.FC<{ dados: DadosUrbanizacao }> = ({ dados }) => {
  return (
    <TableContainerCustomizado>
      <Table data-cy="tableUrbanizacao">
        {dados.itensUrbanizacao.map((itemUrbanizacao: Custo, index: number) => (
          <TableRowCinza key={`itemUrbanizacao${index}`}>
            <TableCellLabel data-cy={`campoUrbanizacaoDescricao${index}`}>{itemUrbanizacao.descricao}</TableCellLabel>
            <TableCellValor data-cy={`campoUrbanizacaoValor${index}`}>
              <NumberFormat
                value={itemUrbanizacao.valor}
                displayType="text"
                thousandSeparator="."
                decimalSeparator=","
                allowEmptyFormatting={true}
                defaultValue="-"
                fixedDecimalScale={true}
                decimalScale={0}
              ></NumberFormat>
            </TableCellValor>
          </TableRowCinza>
        ))}
        <TableRowVerde>
          <TableCellBold>Valor Total (R$)</TableCellBold>
          <TableCellBoldAlignRight data-cy="campoUrbanizacaoValorTotal">
            <NumberFormat
              value={dados.valorTotal}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellBoldAlignRight>
        </TableRowVerde>
      </Table>
    </TableContainerCustomizado>
  )
}

export default CartaoUrbanizacao
